<div id="demographics" class="registration container">
  <form #demographicsForm="ngForm" [ngClass]="{'form-complete': demographicsForm.valid }" (ngSubmit)="forward(demographicsForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.DEMOGRAPHICS.heading' | copy | async }}</h1>
    <section class="card" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Sponsor' || 
      varTrack.Value === 'Home Office' || varTrack.Value === 'Commonwealth Client' || attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24" >
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.subheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <!--First Time Quesiton-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client')">
            <label class="w-100 " for="firstTime" aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttimedemo'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varFirstTime.Value" name="firstTimeValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client' || attendee.PAXTypeNo === 27) && varFirstTime.Value === 'No'">
            <mat-form-field class="w-100">
              <label>{{'copy.label.DEMOGRAPHICS.pastattendee' | copy | async}}</label>
              <mat-select disableRipple name="pastattendance" id="pastattendance" #pastattendance="ngModel" [(ngModel)]="varPastEventsAttend.Value" required>
                <mat-option *ngFor="let ss of timesattending" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Sponsor' || varTrack.Value === 'Home Office' || varTrack.Value === 'Commonwealth Client' || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24" class="w-100">
            <label class="w-100" for="varveteran">{{'copy.label.ATTENDEE.veteran' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="varveteran" id="varveteran" #varveteran="ngModel" [(ngModel)]="varVeteran.Value" required>
                <mat-option *ngFor="let ss of veteranlist" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="varVeteran.Value === 'Yes - Other'">
              <mat-label for="veteranother" aria-labelledby="veteranother" [ngClass]="{'active' : varVeteranOther.Value}">{{ 'copy.label.ATTENDEE.veteranother' | copy | async }}</mat-label>
              <input matInput name="veteranother" id="veteranother" [attr.aria-label]="veteranother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varVeteranOther.Value" #veteranother="ngModel" required/>
              <mat-error><app-validation  [object]="veteranother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Sponsor' || varTrack.Value === 'Home Office' || varTrack.Value === 'Commonwealth Client' || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24" class="w-100">
            <label class="w-100" for="varfirstresponder">{{'copy.label.ATTENDEE.firstresponder' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="varfirstresponder" id="varfirstresponder" #varfirstresponder="ngModel" [(ngModel)]="varFirstresponder.Value" required>
                <mat-option *ngFor="let ss of firstresponderlist" value="{{ss.value}}">{{ss.display}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="varFirstresponder.Value === 'Yes - Other'">
              <mat-label for="firstresponder" aria-labelledby="firstresponder" [ngClass]="{'active' : varFirstresponderOther.Value}">{{ 'copy.label.ATTENDEE.firstresponderother' | copy | async }}</mat-label>
              <input matInput name="firstresponder" id="firstresponder" [attr.aria-label]="firstresponder" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varFirstresponderOther.Value" #firstresponder="ngModel" required/>
              <mat-error><app-validation  [object]="firstresponder" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <label class="w-100" for="stock" aria-labelledby="stock">{{'copy.label.ATTENDEE.lplastock'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varLPLAStockholder.Value" name="stock" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>



          <!--Sponsor Pre Conference Question-->
          <div class="w-100 required" *ngIf="attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 28">
            <label class="w-100" [innerHTML]='"copy.html.demosponsorpreconf" | copy | async'></label>
            <!--a matTooltip="{{'copy.label.DEMOGRAPHICS.preconftooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a-->
            <mat-radio-group class="w-100" [(ngModel)]="varSponsorPreConference.Value" name="sponsorpreconfValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field class="w-100"  *ngIf="attendee.PAXTypeNo === 28">
            <mat-label for="supplierrole" aria-labelledby="supplierrole" [ngClass]="{'active' : varSupplierRole.Value}">{{ 'copy.label.DEMOGRAPHICS.supplierrole' | copy | async }}</mat-label>
            <input matInput name="supplierrole" id="supplierrole" [attr.aria-label]="supplierrole" type="text" class="form-control" maxlength="50" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varSupplierRole.Value" #supplierrole="ngModel" required />
            <mat-error><app-validation  [object]="supplierrole" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
          <p class="w-100"  *ngIf="attendee.PAXTypeNo === 28" [innerHTML]='"copy.html.supplierrolenote" | copy | async'></p>

          <!--Preconf Designated Speaker Question-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Home Office' && attendee.PAXTypeNo !== 29 && attendee.PAXTypeNo !== 52 && attendee.PAXTypeNo !== 21)  || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 22">
            <label class="w-100 " for="desigspeakerValue" aria-labelledby="desigspeakerValue">{{'copy.label.DEMOGRAPHICS.designatedspeaker'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varDesignatedSpeaker.Value" name="desigspeakerValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field class="w-100" *ngIf="varDesignatedSpeaker.Value === 'Yes'">
            <mat-label for="sessionDesig">{{'copy.label.DEMOGRAPHICS.sessionDesignation' | copy | async }}</mat-label>
            <input matInput name="sessionDesig" id="sessionDesig" type="text" maxlength="60" pattern="^[A-Za-z0-9\s\-\_'.]*$" [(ngModel)]="varSessionDesignation.Value" #sessionDesignation="ngModel" required />
            <mat-error><app-validation  [object]="sessionDesignation" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>


        

        </div>
        </article>
      </section>

      <section class="card" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
        <div class="card-header">
          <div class="card-title">
            {{ 'copy.label.DEMOGRAPHICS.profInterestSubheading' | copy | async }}
          </div>
        </div>
        <article>
          <div class="card-body w-100">

            <div class="w-100 required" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
              <label class="label-display">
                <span [innerHTML]="'copy.label.DEMOGRAPHICS.careerStage'|copy|async"></span>
              </label>
              <mat-radio-group class="w-100" [(ngModel)]="varCareerStage.Value" name="careerStageValue" required>
                <mat-radio-button *ngFor="let stage of careerStageList" value="{{stage}}">{{stage}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="survey-container" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
              <!-- Question 1: Learning Topics (Rank Top 3) -->
              <div class="question-section">
                <h3>{{ 'copy.label.DEMOGRAPHICS.learningHeader' | copy | async }}<span class="required-asterisk">*</span></h3>
                <p class="instruction">
                  Select {{ questions[0].maxSelections }} options, then drag to rank
                  <span class="selection-count">
                    ({{ getSelectedCount(questions[0]) }}/{{ questions[0].maxSelections }} selected)
                  </span>
                </p>
                <div class="selection-area">
                  <h3>Available Options</h3>
                  <div class="options-list">
                    <div 
                      *ngFor="let option of questions[0].options"
                      class="option-item checkbox-option"
                      [class.selected]="option.selected"
                      [class.disabled]="!option.selected && !canSelectMore(questions[0])">
                      
                      <mat-checkbox name="q1-{{ option.id }}" [checked]="option.selected" 
                      [disabled]="!option.selected && !canSelectMore(questions[0])" 
                      (change)="toggleOption(questions[0], option)" [ngModel]="questions[0].rankedOptions?.includes(option)" 
                      [required]="(!questions[0].hasError || (questions[0]?.rankedOptions?.length || 0) < 3)">
                      {{ option.text }}</mat-checkbox>

                    </div>
                    <mat-error *ngIf="questions[0].hasError">{{ 'copy.label.DEMOGRAPHICS.rankingError' | copy | async }}</mat-error>
                  </div>
                </div>

                <!-- Ranking Area -->
                <div class="ranking-area" *ngIf="questions[0].rankedOptions && questions[0].rankedOptions.length > 0">
                  <h3>Your Rankings <span class="rank-instruction">(Drag to reorder)</span></h3>
                  <div 
                    cdkDropList
                    class="ranked-list"
                    (cdkDropListDropped)="dropTopic($event, questions[0])">
                    <div 
                      *ngFor="let option of questions[0].rankedOptions; let i = index"
                      class="ranked-item" 
                      cdkDrag cdkDragHandle>
                      <div class="rank-number">{{ i + 1 }}</div>
                      <div class="rank-content">
                        <mat-icon class="drag-handle">drag_indicator</mat-icon>
                        <span class="rank-text">{{ option.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Question 2: Business Challenges (Rank Top 3) -->
              <div class="question-section">
                <h3>{{ 'copy.label.DEMOGRAPHICS.challengesHeader' | copy | async }}<span class="required-asterisk">*</span></h3>
                <p class="instruction">
                  Select {{ questions[1].maxSelections }} options, then drag to rank
                  <span class="selection-count">
                    ({{ getSelectedCount(questions[1]) }}/{{ questions[1].maxSelections }} selected)
                  </span>
                </p>
                
                <div class="selection-area">
                  <h3>Available Options</h3>
                  <div class="options-list">
                    <div 
                      *ngFor="let option of questions[1].options"
                      class="option-item checkbox-option"
                      [class.selected]="option.selected"
                      [class.disabled]="!option.selected && !canSelectMore(questions[1])">

                      <mat-checkbox name="q2-{{ option.id }}" [checked]="option.selected" 
                      [disabled]="!option.selected && !canSelectMore(questions[1])" 
                      (change)="toggleOption(questions[1], option)" [ngModel]="questions[1].rankedOptions?.includes(option)" 
                      [required]="(!questions[1].hasError || (questions[1]?.rankedOptions?.length || 0) < 3)">
                      {{ option.text }}</mat-checkbox>
                      
                    </div>
                    <mat-error *ngIf="questions[1].hasError">{{ 'copy.label.DEMOGRAPHICS.rankingError' | copy | async }}</mat-error>
                  </div>
                </div>

                <!-- Ranking Area -->
                <div class="ranking-area" *ngIf="questions[1].rankedOptions && questions[1].rankedOptions.length > 0">
                  <h3>Your Rankings <span class="rank-instruction">(Drag to reorder)</span></h3>
                  <div 
                    cdkDropList
                    [cdkDropListData]="questions[1].rankedOptions"
                    class="ranked-list"
                    (cdkDropListDropped)="dropChallenge($event, questions[1])">
                    <div 
                      *ngFor="let option of questions[1].rankedOptions; let i = index"
                      class="ranked-item"
                      cdkDrag cdkDragHandle>
                      <div class="rank-number">{{ i + 1 }}</div>
                      <div class="rank-content">
                        <mat-icon class="drag-handle">drag_indicator</mat-icon>
                        <span class="rank-text">{{ option.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <br/>
            <div class="w-100" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
              <label class="w-100" for="mostExcitedInput">{{'copy.label.DEMOGRAPHICS.mostExcited' | copy | async }}<span class="required-asterisk">*</span></label>
              <div class="d-flex justify-content-start w-100">
                <mat-form-field class="w-100">
                  <!-- <mat-label for="mostExcitedInput">{{ 'copy.label.DEMOGRAPHICS.mostExcited' | copy | async }}</mat-label> -->
                  <textarea matInput class="w-100" name="mostExcitedInput" id="mostExcitedInput" aria-label="mostExcitedInput" [(ngModel)]="mostExcited.Value" #excited="ngModel" maxlength="125" pattern="^[\w\s!@\-\_:',.\/?]*" required></textarea>
                  <mat-error><app-validation  [object]="excited" isRequired=true pattern="alphanum"></app-validation></mat-error>
                </mat-form-field>
              </div>
            </div>

          </div>
        </article>
      </section>
      
    <section class="card" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.pacSubheading' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50" class="w-100">
            <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
              <label class="w-100" for="firstTime">{{'copy.label.ATTENDEE.contributelplpac' | copy | async }}</label>
              <mat-form-field class="w-100">
                <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
                <mat-select disableRipple name="contribute" id="contribute" #contribute="ngModel" [(ngModel)]="varContribute.Value" required>
                  <mat-option *ngFor="let response of contributeResponses" value="{{response.value}}">{{response.display}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="varContribute.Value === 'Yes'">
                <div class="w-100" [innerHTML]='"copy.html.LPLPAC1" | copy | async'></div>

                <mat-form-field class="w-100 twoLineSelect">
                  <mat-label>{{ 'copy.label.ATTENDEE.contribution' | copy | async }}</mat-label>
                  <mat-select name="contributiondropdown" id="contributiondropdown" #contributiondropdown="ngModel" [(ngModel)]="this.enrollment.$mtccontributetemp" required>
                    <mat-option *ngFor="let x of contributiondropdownlist" value="{{x}}">{{x}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-100 longQuestionText" *ngIf="this.enrollment.$mtccontributetemp === 'Other'">
                  <mat-label for="contribution" aria-labelledby="contribution" [ngClass]="{'active' : contribution}">{{ 'copy.label.ATTENDEE.otheramount' | copy | async }}</mat-label>
                  <input matInput name="contribution" id="contribution" [attr.aria-label]="contribution" type="number" min="250" maxlength="100" pattern="^(0|[0-9][0-9]*)$"[(ngModel)]="varContribution.Value" #contribution="ngModel" required/>
                  <mat-error *ngIf="contribution.hasError('min')">
                    {{'copy.label.ATTENDEE.contributionminerror'|copy|async}}
                  </mat-error>
                  <mat-error><app-validation  [object]="contribution" isRequired=true pattern="alphanum"></app-validation></mat-error>
                </mat-form-field>

                <label class="w-100" for="initials"><i>{{'copy.label.ATTENDEE.contributionnote' | copy | async }}</i></label>
                <mat-form-field class="w-100">
                  <mat-label for="initials" aria-labelledby="initials" [ngClass]="{'active' : initials}">{{ 'copy.label.ATTENDEE.initials' | copy | async }}</mat-label>
                  <input matInput name="initials" id="initials" [attr.aria-label]="initials" type="text" maxlength="10" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="varInitials.Value" #initials="ngModel" required/>
                  <mat-error><app-validation  [object]="initials" isRequired=true pattern="alpha"></app-validation></mat-error>
                </mat-form-field>
                <div class="w-100" [innerHTML]='"copy.html.LPLPAC2" | copy | async'></div>
              </div>

              <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
                <label class="w-100" for="stateNetwork" aria-labelledby="stateNetwork">
                  <span [innerHTML]="'copy.html.stateNetwork'|copy|async"></span>
                  <span>&nbsp;<a class="ml-1" matTooltip="{{'copy.label.ATTENDEE.stateNetworkToolTip'|copy|async}}">
                    <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
                  </a></span>

                </label>
                <mat-radio-group class="w-100" [(ngModel)]="stateNetwork.Value" name="stateNetworkValue" required>
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <section class="card" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 54 || attendee.PAXTypeNo === 53) && attendee.PAXTypeNo !== 50 && !isRegComplete">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.donationSubheading' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <!--Donation Questions-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 54 || attendee.PAXTypeNo === 53) && attendee.PAXTypeNo !== 50 && !isRegComplete">
            <!-- <label class="w-100 " for="firstTime" aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttime'|copy|async}}</label> -->
            <div class="w-100" [innerHTML]='"copy.html.demodonation" | copy | async'></div>
            <label class="w-100">{{'copy.label.DEMOGRAPHICS.foundationquestion'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varDonation.Value" name="donationValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field class="w-100" *ngIf="varDonation.Value === 'Yes' && !isRegComplete">
            <label>{{'copy.label.DEMOGRAPHICS.donationamount' | copy | async}}</label>
            <mat-select disableRipple name="donationamount" id="donationamount" #donationamount="ngModel" [(ngModel)]="varDonationAmount.Value" required>
              <mat-option *ngFor="let ss of donationvalues" value="{{ss}}">{{ss}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100" *ngIf="varDonationAmount.Value === 'Other' && varDonation.Value === 'Yes' && !isRegComplete">
            <label for="donateother" aria-labelledby="donateother" [ngClass]="{'active' : donateother}">{{ 'copy.label.DEMOGRAPHICS.donationother' | copy | async }}</label>
            <input matInput name="donateother" id="donateother" [attr.aria-label]="donateother" type="number" class="form-control" maxlength="100" pattern="^(0|[0-9][0-9]*)$" [(ngModel)]="varDonationOther.Value" #donateother="ngModel" required/>
            <mat-error><app-validation  [object]="donateother" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </article>

    </section>
          <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.commSubheading' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <div class="required w-100">
            <label class="w-100" for="smstext">{{'copy.label.ATTENDEE.smstext' | copy | async }} <a matTooltip="{{'copy.label.ATTENDEE.smstexttooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a></label>
            <mat-radio-group class="w-100" [(ngModel)]="SMStext.Value" required #smstext="ngModel" name="smstext">
              <mat-radio-button [value]="'Yes'">Yes</mat-radio-button>
              <mat-radio-button [value]="'No'">No</mat-radio-button>
              <div class="w-100">
                <app-validation  [object]="smstext" isRequired=true></app-validation>
              </div>
            </mat-radio-group>
          </div>

          <div class="w-100" *ngIf="SMStext.Value === 'Yes'">
            <label class="w-100" for="smsprovider">{{'copy.label.ATTENDEE.smsprovider' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="smsprovider" id="smsprovider" #stock="ngModel" [(ngModel)]="SMSprovider.Value" required>
                <mat-option *ngFor="let ss of providervalues" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <div class="w-100" *ngIf="SMStext.Value === 'Yes' && SMSprovider.Value === 'Other'">
            <mat-form-field class="w-100">
              <mat-label for="smsproviderother" aria-labelledby="smsproviderother" [ngClass]="{'active' : smsproviderother}">{{ 'copy.label.ATTENDEE.smsproviderother' | copy | async }}</mat-label>
              <input matInput name="smsproviderother" id="smsproviderother" [attr.aria-label]="smsproviderother" type="text" maxlength="50" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="SMSproviderother.Value" #smsproviderother="ngModel" required/>
              <app-validation  [object]="smsproviderother" isRequired=true></app-validation>
            </mat-form-field>
          </div>

          <div class="w-100" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
            <div class="w-100">{{'copy.label.ATTENDEE.promotionalemail' | copy | async }}</div>
            <div class="agreeCheckbox">
              <div class="checkboxFlexContainer">
                <mat-checkbox name="promotionalemail" [ngModel]="attendee.$mtcOptOut" (change)="attendee.$mtcOptOut = !attendee.$mtcOptOut" aria-labelledby="promotionalemail_label"></mat-checkbox>
                <label id="promotionalemail_label">{{'copy.label.ATTENDEE.optOut' | copy | async }}</label>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
        <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
        <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
      </button>
      <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>

